import { render, staticRenderFns } from "./BlogPostsDescription.vue?vue&type=template&id=4d6ac125&"
import script from "./BlogPostsDescription.vue?vue&type=script&lang=js&"
export * from "./BlogPostsDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports